import Image from 'next/image';
import React from 'react';
import { useTranslations } from 'next-intl';
import clsx from 'clsx';
import styles from './PersonalPlan.module.scss';
import LocaleSwitcher from '@/components/LocaleSwitcher/LocaleSwitcher';
import { useShowLocaleSwitcher } from '@/hooks/useShowLocaleSwitcher';

const steps = [
  { key: 'start', label: 'Your configuration', dots: 5 },
  { key: 'pending', label: 'Your details', dots: 1 },
  { key: 'done', label: 'Personal plan title', dots: 1 },
];

const PersonalPlanHeader = ({ stage = 'done' }: { stage?: 'start' | 'pending' | 'done' }) => {
  const t = useTranslations('PersonalPlan');
  const showLocale = useShowLocaleSwitcher();

  return (
    <header className={styles.topbar}>
      <div className={styles.brand}>
        <Image
          src='/logo.svg'
          alt='Art of You'
          width={203}
          height={38}
          priority
        />
      </div>

      <nav
        className={styles.steps}
        aria-label='Progress'
      >
        <ol className={styles.stepList}>
          {steps.map(({ key, label, dots }, index) => {
            let isActive = false;

            switch (stage) {
              case 'start':
                isActive = index === 0;
                break;
              case 'pending':
                isActive = index <= 1;
                break;
              case 'done':
                isActive = true;
                break;
              default:
                isActive = false;
            }

            return (
              <li
                key={key}
                className={clsx(styles.stepItem, { [styles.isActive]: isActive })}
                aria-current={stage === key ? 'page' : undefined}
              >
                <span className={styles.stepLabel}>{t(label)}</span>
                <span className={styles.dots}>
                  {Array.from({ length: dots }).map((_, i) => (
                    <span
                      // eslint-disable-next-line react/no-array-index-key
                      key={i}
                      className={styles.dot}
                    />
                  ))}
                </span>
              </li>
            );
          })}
        </ol>
      </nav>
      {(!['start', 'pending'].includes(stage) && showLocale) && (
        <div className={clsx(styles.right)}>
          <LocaleSwitcher />
        </div>
      )}
    </header>
  );
};

export default PersonalPlanHeader;
